export const setDocumentTitle = title => document.title = `Forms - ${title} - Intrado Inc.`;
